module.exports = __webpack_public_path__ + "static/media/dr-wells.a99ac690.png";